import React, {useState, useEffect} from 'react';

export default function Select({options, value, onChange, placeholder, allowDeselect, displayArrow, isOpen, dwhReport}) {
  const [selectedValue, setSelectedValue] = useState(value);
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  useEffect(() => {
    if (dwhReport && open) {
      dwhReport();
    }
  }, [open]);

  const selectedOption = options.find((option) => option.id === selectedValue);
  const displayedText = selectedOption ? `${selectedOption.id} - ${selectedOption.name}` : placeholder;

  function updateValue(val) {
    onChange(val);
    setSelectedValue(val);
    setOpen(false);
  }

  return (
    <div className={'wrapper' + (open ? ' open' : '')} data-simplebar>
      <div
        className={'toggle' + (open ? ' open' : '')}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(!open);
        }}>
        {displayedText}
        {displayArrow ? <div className='select-arrow' /> : null}
      </div>
      <div className='select-dropdown'>
        {allowDeselect ? (
          <div
            key='__NULL_OPTION_KEY__'
            className='select-option'
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              updateValue(null);
            }}>
            &nbsp;
          </div>
        ) : null}
        {options.map((option) => (
          <div
            key={option.id}
            value={option.name}
            className={'select-option' + (option === selectedOption ? ' selected' : '')}
            title={option.name + '' + option.id}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              updateValue(option.id);
            }}>
            {option.id} - {option.name}&nbsp;
          </div>
        ))}
      </div>
    </div>
  );
}
